/**
 * @file Defines the {@link BUTTON_CONFIG} constant
 * @author Joe Thompson <joe.thompson@1x2network.com>
 * @version 1.0.32
*/

/**
 * Button config.
 * @type {object}
 * @constant
 * @default
 * @property {object}   console  - Console config.
 * @property {object}   autospin - Autospin button config.
 * @property {object}   bet      - Bet button config.
 * @property {object}   menu     - Menu button config.
 * @property {object}   paytable - Paytable button config.
 * @property {object}   sound    - Sound button config.
 * @property {object}   spin     - Spin button config.
 * @property {string}   layout   - Side of the UI button appears.
 * @property {string[]} states   - Button states.
 * @property {string[]} text     - Buttons description text to translate in game guide
 * @property {boolean|string} ignore - Whether to ignore button or a particular state in button description
 * @property {optional-button-config} optional - Config which checks whether button is needed in button description
 */
export const BUTTON_CONFIG = {

    console: {

        autospin: {

            layout:     'rightWrapper',
            states:     [ 'START', 'SPIN', 'STOP' ],
            text:       [ 'Autoplay Button', 'Autoplay Start Button', 'Autoplay Stop Button' ],
            optional:   { check: { func: 'getCanAutoplay_', negate: true }, id: 'autoplay' }

        },

        bet: {

            layout: 'leftWrapper',
            states: [ 'BET' ],
            text:   [ 'Bet Control' ],

        },

        menu: {

            layout: 'leftWrapper',
            states: [ 'CLOSE', 'MENU' ],
            text:   [ 'Close Menu', 'Open Menu' ],

        },

        paytable: {

            layout: 'leftWrapper',
            states: [ 'CLOSE', 'PAYTABLE' ],
            text:   [ 'Close Help', 'Help Button' ],
            ignore: 'CLOSE'

        },

        sound: {

            layout: 'rightWrapper',
            states: [ 'OFF', 'ON' ],
            text:   [ 'Mute Sound', 'Unmute sound' ],

        },

        spin: {

            layout: 'rightWrapper',
            states: [ 'SPIN', 'STOP' ],
            text:   [ 'Spin Button', 'Stop Button' ],
            ignore: { 'STOP': { func: 'getCanQuickPlay_' } }

        }

    }

}